import { createContext } from 'react';
import { IConfirmationModalContextState } from '@components/Confirm/context/types';

export const ConfirmationModalContext = createContext<IConfirmationModalContextState | undefined>(undefined);
